/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'back',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'close',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Referencing',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Actions',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': 'Loading conversation starters...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Ask Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Give feedback',
  'ai-smart-button.ai-actions.help.section.text': 'Help',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Mention',
  'ai-smart-button.ai-actions.input.placeholder': 'Type what you need',
  'ai-smart-button.ai-actions.input.send-button-label': 'Send',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NEW',
  'ai-smart-button.ai-actions.no-results-heading': 'Ask Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Send your prompt to Rovo to start a chat.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Add icon',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Agent icon',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Automation icon',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automations',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Browse agents',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Create agent',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Create automation',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'What are Rovo Agents?',
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'How can I use Rovo Agents in my Confluence space?',
  'ai-smart-button.ai-actions.static-fallback-1': 'What is Rovo Chat?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Help me get started with Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'How can I help?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hi {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Dismiss',
  'ai-smart-button.feedback-action.ask-question-option': 'Ask a question',
  'ai-smart-button.feedback-action.can-contact-message':
    'Yes, {product} teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privacyPolicy}',
  'ai-smart-button.feedback-action.can-contact-message-appify':
    'Yes, {product} teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Cancel',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Choose one',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Describe the bug or issue',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Let us know what's on your mind",
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'What would you like to know?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Let us know what you'd like to improve",
  'ai-smart-button.feedback-action.leave-comment-option': 'Leave a comment',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product} Privacy Policy.',
  'ai-smart-button.feedback-action.report-bug-option': 'Report a bug',
  'ai-smart-button.feedback-action.research-participation-message': "I'd like to participate in product research",
  'ai-smart-button.feedback-action.select-feedback-heading': 'Select feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Send feedback',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Suggest an improvement',
  'ai-smart-button.feedback-action.title': 'Give feedback',
  'ai-smart-button.feedback-item.icon-label': 'Feedback icon',
  'ai-smart-button.reference.close-button-label': 'Close',
  'ai-smart-button.tooltip.label': 'Ask Rovo AI',
  'quick-summary.feedback.summary.placeholder': 'What did Atlassian Intelligence do well? What could be improved?',
  'quick-summary.feedback.title': 'Help us improve Atlassian Intelligence',
};
